import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

const getStatus = (record: iMedicine) => {
    if (!record.due_date) return "Sem vencimento";
    return moment(record.due_date).isBefore(moment(), "day") ? "Vencido" : "Em estoque";
};

export const exportMedicinesReportPdf = (records: iMedicine[], filterSummary: string[], sort: { field: string; direction: string }) => {
    const doc = new jsPDF({ orientation: "landscape" });

    doc.setFontSize(14);
    doc.text("Relatório de Medicamentos", 14, 15);

    doc.setFontSize(9);
    doc.text(`Gerado em: ${moment().format("DD/MM/YYYY HH:mm")}`, 14, 21);
    doc.text(`Ordenado por: ${sort.field} (${sort.direction === "desc" ? "decrescente" : "crescente"})`, 14, 26);

    let tableStartY = 31;

    if (filterSummary.length) {
        doc.text(`Filtros: ${filterSummary.join(" | ")}`, 14, 31);
        tableStartY = 36;
    }

    autoTable(doc, {
        startY: tableStartY,
        head: [["Nome", "Necessidade", "Estoque", "Caixa", "Vencimento", "Cadastrado em", "Status"]],
        body: records.map(record => [
            record.name,
            record.need,
            record.stock,
            record.box,
            record.due_date ? moment(record.due_date).utc().format("DD/MM/YYYY") : "-",
            record.created_at ? moment(record.created_at).utc().format("DD/MM/YYYY") : "-",
            getStatus(record),
        ]),
        styles: { fontSize: 8 },
        headStyles: { fillColor: [41, 128, 185] },
    });

    doc.save(`relatorio-medicamentos-${moment().format("YYYY-MM-DD-HHmm")}.pdf`);
};
